import {useEffect, type RefObject} from 'react';

/**
 * Keeps the chat pinned to the newest content: the sent message, the typing
 * indicator and the answer that replaces it. Runs after commit so scrollHeight
 * already includes what was just rendered.
 */
export function useScrollToLatestMessage(
    scrollColumnRef: RefObject<HTMLDivElement>,
    messageCount: number,
    draftLoading: boolean,
): void {
    useEffect(() => {
        const scrollEl = scrollColumnRef.current;
        if(!scrollEl || !messageCount) {
            return;
        }
        // One frame lets images and the typing indicator take up their height first.
        const frame = requestAnimationFrame(() => {
            scrollEl.scrollTo({top: scrollEl.scrollHeight, behavior: 'smooth'});
        });
        return () => cancelAnimationFrame(frame);
    }, [scrollColumnRef, messageCount, draftLoading]);
}
